import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToastType } from '../../../services/toast.service';

interface ToastData {
    message: string;
    toastType: ToastType;
    actionText?: string;
    action?: () => any;
}

@Component({
    selector: 'app-toast-notification',
    templateUrl: './toast-notification.component.html',
    styleUrls: ['./toast-notification.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ToastNotificationComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ToastData, public snackRef: MatSnackBarRef<ToastNotificationComponent>) {}

    get Icon() {
        switch (this.data.toastType) {
            case 'success':
                return 'check_circle';
            case 'error':
                return 'error';
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            case 'neutral':
            default:
                return '';
        }
    }

    public closeToast(): void {
        this.snackRef.dismiss();
    }
}
